const apiUrl = "https://portal.edge-solutions.online/api/";
const apiOnlineMenuUrl = "https://menu.edge-solutions.online/api/";
const clientOnlineMenuUrl = "https://menu.edge-solutions.online";
const apiBookingUrl = "https://booking.edge-solutions.online/api/";
const apiRealEstateUrl = "https://realestate.edge-solutions.online/api/";
const apiLoyaltyProgramUrl = "https://loyalty.edge-solutions.online/api/";

const getToken = () => {
  return localStorage.getItem("project_management_platform_token") || null;
};

const getApplicationToken = (applicationSlug) => {
  return (
    localStorage.getItem(
      "project_management_platform_token_" + applicationSlug
    ) || null
  );
};

const saveToken = (token) => {
  localStorage.setItem("project_management_platform_token", token);
  return true;
};

const saveApplicationToken = (applicationSlug, token) => {
  localStorage.setItem(
    "project_management_platform_token_" + applicationSlug,
    token
  );
  return true;
};

const deleteToken = () => {
  localStorage.removeItem("project_management_platform_token");
  return true;
};

const deleteApplicationToken = (applicationSlug) => {
  localStorage.removeItem(
    "project_management_platform_token_" + applicationSlug
  );
  return true;
};

const executeRequest = async (
  url,
  method,
  data,
  headers = {},
  onSuccess,
  onError
) => {
  try {
    const options = {
      method: method,
      headers: {
        Accept: "application/json",
        ...headers,
      },
    };

    // Check if data exists and is not a GET request
    if (method !== "GET" && data) {
      // Set the body of the request to the form data
      options.body = data;
    }

    // Make the fetch request
    const response = await fetch(url, options);

    // If the response is not ok, handle the error
    if (!response.ok) {
      const errorText = await response.text();
      try {
        const errorData = JSON.parse(errorText);
        return onError(errorData.message || "Request failed");
      } catch {
        return onError("Request failed");
      }
    }

    // Parse the response text into JSON
    const text = await response.text();
    const responseData = text ? JSON.parse(text) : {};

    // Call the success callback
    onSuccess(responseData);
  } catch (e) {
    // Catch network errors or other exceptions
    onError(e.message || "Network error");
  }
};

export {
  apiUrl,
  apiOnlineMenuUrl,
  clientOnlineMenuUrl,
  apiBookingUrl,
  apiRealEstateUrl,
  apiLoyaltyProgramUrl,
  getToken,
  getApplicationToken,
  saveToken,
  saveApplicationToken,
  deleteToken,
  deleteApplicationToken,
  executeRequest,
};
